import { createSlice } from '@reduxjs/toolkit';


interface permission{
    permissions:any,
    navigateTabsArray:Array<Object>,
    nestedPermissionsData:Array<Object>,
    getFilterPermissionsObject:any, 
}

const initialState:permission = {
    permissions:"",
    navigateTabsArray:[],
    nestedPermissionsData:[],
    getFilterPermissionsObject:{}, 
};
const modalSlice = createSlice({
    name: 'permissions',
    initialState,
    reducers: {
        setPermission: (state, action) => {
            return { ...state, isOpen: true, ...action.payload }
        },
        
    },
});
export const { setPermission } = modalSlice.actions;
export default modalSlice.reducer;
